import * as React from 'react';
import { UploadVideos } from 'features/DigitalMarketing/pages/UploadVideos';

type UploadVideoRoute = {
  subPath?: string;
  element: React.ReactElement;
};

export const UPLOAD_VIDEO_ROUTES: UploadVideoRoute[] = [
  { element: <UploadVideos /> },
  { subPath: 'create', element: <UploadVideos /> },
  // Preview flow is disabled; videos are submitted directly from the upload form.
  // { subPath: 'preview', element: <UploadVideos /> },
];

export const UPLOAD_VIDEO_SUB_ROUTES = UPLOAD_VIDEO_ROUTES.map(route => ({
  path: route.subPath ? `upload-videos/${route.subPath}` : 'upload-videos',
  element: route.element,
}));
